// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.greengloryglobal",
    name: "Blockaura",
    homepage: "https://greengloryglobal.com/",
    image_id: "8cc7ddbc-a257-4383-4f84-3847e707bb00",
    app: {
        browser: null,
        ios: null,
        android: "https://play.google.com/store/apps/details?id=com.blockaura_classic",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "blockaura://walletconnect",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map